import PopupComponent from '../popup-component';
import template from './template';

export default class RoboFeedbackPopup extends PopupComponent {
  constructor(config) {
    super();
    this.classMap = {
      positive: 'robo_happy',
      negative: 'robo_sad',
      neutral: 'robo_neutral',
    };
    const popupConfig = {
      id: 'popup_robo_feedback',
      initializedCallback: () => this._onInit(),
      buttons: config.buttons,
    };
    const useTranslator = config.useTranslator || true;
    this.msg = useTranslator ? this.t(config.message) : config.message;
    this.mood = config.mood;
    this.popup = this.create(popupConfig);
    this.createContentElement('popup_robo_feedback', template);
  }

  _onInit() {
    let className = this.classMap[this.mood];
    if (!className) {
      className = this.classMap.neutral;
      console.warn(`mood "${this.mood}" not found. Using "neutral" instead.`);
    }
    this.popup.wrapperElement.querySelector('.popup_content .robo_message').innerHTML = this.msg;
    const robo = this.popup.wrapperElement.querySelector('.popup_content .robo_image');
    robo.classList.add(className);
  }
}
